import { getCookieValue } from 'utils/cookies';
import { shorterDate, shorterTime } from 'utils/date';

export const formatEventTime = (
  localizedStarts: Date,
  localizedEnds: Date | null | undefined
) => {
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2-3 arguments, but got 1.
  let formattedTime = `${shorterDate(localizedStarts)}, ${shorterTime(
    localizedStarts
  )}`;

  if (localizedEnds) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 2-3 arguments, but got 1.
    formattedTime += ` - ${shorterTime(localizedEnds)}`;
  }

  return formattedTime;
};
export const combineFormDateTime = (date: string, time: string) =>
  `${date}T${time}`;
export const splitFormDateTime = (
  dt: string
): {
  date: string | null | undefined;
  time: string | null | undefined;
} => {
  const dateParts = dt.split('T');
  return {
    date: dateParts[0],
    time: dateParts[1],
  };
};
export const isEnabled = () => getCookieValue('_idealistDaysEnabled') === '1';
